import UserDomain from "../domains/UserDomain";
import UserSessionDomain from "../domains/UserSessionDomain";
import ApiDomain from "../domains/APIDomain";
import DashboardDomain from "../domains/DashboardDomain";
import BillDetailsDomain from "../domains/BillDetailsDomain";
import FilterDomain from "../domains/FilterDomain";
import CommonUtilityDomain from "../domains/CommonUtilityDomain";
import BillerDirectoryDomain from "../domains/BillerDirectoryDomain";
import SimpleMessageDomain from "../domains/SimpleMessageDomain";
import CommonQueryDomain from "../domains/CommonQueryDomain";
import UserLoginDomain from "../domains/UserLoginDomain";
import UserSearchHistoryDomain from "../domains/UserSearchHistoryDomain";
import UserRegistrationDomain from "../domains/UserRegistrationDomain";
import MiscellaneousDomain from "../domains/MiscellaneousDomain";
import MyPreferenceDomain from "../domains/MyPreferenceDomain";
import NotificationDomain from "../domains/NotificationDomain";
import BillRequestDomain from "../domains/BillRequestDomain"
import TextToPayDomain from "../domains/TextToPayDomain"
import ACHPaymentDomain from "../domains/ACHPaymentDomain";
import KeyCloakAPIDomain from "../domains/KeyCloakAPIDomain";

const domain = {
  domain: {
    user: UserDomain,
    userSession: UserSessionDomain,
    rest: ApiDomain,
    dashboard: DashboardDomain,
    billDetails: BillDetailsDomain,
    filterDomain: FilterDomain,
    commonDomain: CommonUtilityDomain,
    billerDirectoryDomain: BillerDirectoryDomain,
    simpleMessage: SimpleMessageDomain,
    queryDomain: CommonQueryDomain,
    userLoginDomain: UserLoginDomain,
    userSearchDomain: UserSearchHistoryDomain,
    userRegistration: UserRegistrationDomain,
    miscellaneousDomain: MiscellaneousDomain,
    myPreferenceDomain: MyPreferenceDomain,
    notificationDomain: NotificationDomain,
    billRequest: BillRequestDomain,
    textToPay: TextToPayDomain,
    achPaymentDomain: ACHPaymentDomain,
    kcAPI: KeyCloakAPIDomain,
  },
  ui: {},
};

export default domain;